(() => {
  const styleId = 'renzen-smartbot-invite-style';
  const css = '[role="region"][aria-label="Notificación"], [role="region"][class*="_notification-card_"] { display: none !important; }';

  function installStyle() {
    const root = document.getElementById('smart-bot-container')?.shadowRoot;
    if (!root) return false;
    if (root.getElementById(styleId)) return true;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = css;
    root.appendChild(style);
    return true;
  }

  if (installStyle()) return;

  const observer = new MutationObserver(() => {
    if (installStyle()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });

  const deadline = Date.now() + 60000;
  const retry = window.setInterval(() => {
    if (installStyle() || Date.now() >= deadline) {
      window.clearInterval(retry);
      observer.disconnect();
    }
  }, 250);
})();
